import React, { useId } from 'react';
import classNames from 'classnames';
import styles from './animatedWaitingIcon.module.scss';

interface AnimatedWaitingIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;

  // ✅ couleurs optionnelles (par défaut = thème global)
  colors?: [string, string, string];
}

export const AnimatedWaitingIcon: React.FC<AnimatedWaitingIconProps> = ({
  width = 30,
  height = 30,
  className,

  // ✅ MODIFIÉ : couleurs par défaut via CSS variables
  colors = [
    'var(--color-0)', // primaire
    'var(--color-0)', // primaire bis
    'var(--color-M)', // secondaire
  ],
}) => {

  // Identifiant unique par instance : deux icônes montées en même temps (ex. ControlBar
  // pendant un démarrage + moniteur du flux final) partageraient sinon le même id de
  // dégradé, et `url(#…)` résoudrait vers la première du document.
  // Les caractères non alphanumériques renvoyés par useId (« :r1: ») sont retirés pour
  // rester valides dans un url(#…).
  const gradientId = `kleonGPlay-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;

  return (
    <div className={classNames(styles.root, className)}>
      <div>
     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" role="img" aria-label="Kleon.tv"
   	    width={width}
        height={height}>
        <defs>

          <linearGradient id={gradientId} gradientUnits="userSpaceOnUse" x1="148" y1="55" x2="148" y2="255">
            <stop offset="0%" stop-color="#2878ff"></stop>
            <stop offset="20%" stop-color="#00aad0"></stop>
            <stop offset="40%" stop-color="#4055e0"></stop>
            <stop offset="60%" stop-color="#6028e8"></stop>
            <stop offset="80%" stop-color="#6838ee"></stop>
            <stop offset="100%" stop-color="#5040f0"></stop>
            <animateTransform attributeName="gradientTransform" type="rotate" from="0 148 155" to="360 148 155" dur="4s" repeatCount="indefinite"></animateTransform>
          </linearGradient>
        </defs>
        <g>
          <animateTransform attributeName="transform" type="rotate" from="0 148 155" to="360 148 155" dur="4s" repeatCount="indefinite"></animateTransform>
          <path d="M 167 77 A 80 80 0 0 1 206 99" fill="none" stroke="#2878ff" stroke-width="8" stroke-linecap="round"></path>
          <path d="M 225 133 A 80 80 0 0 1 225 177" fill="none" stroke="#00aad0" stroke-width="8" stroke-linecap="round"></path>
          <path d="M 206 211 A 80 80 0 0 1 167 233" fill="none" stroke="#4055e0" stroke-width="8" stroke-linecap="round"></path>
          <path d="M 129 233 A 80 80 0 0 1 90 211" fill="none" stroke="#6028e8" stroke-width="8" stroke-linecap="round"></path>
          <path d="M 71 177  A 80 80 0 0 1 71 133" fill="none" stroke="#6838ee" stroke-width="8" stroke-linecap="round"></path>
          <path d="M 90 99   A 80 80 0 0 1 129 77" fill="none" stroke="#5040f0" stroke-width="8" stroke-linecap="round"></path>
          <circle cx="148" cy="55" r="14" fill="#3070ff"></circle>
          <circle cx="235" cy="105" r="14" fill="#00cce0"></circle>
          <circle cx="235" cy="205" r="14" fill="#0090c8"></circle>
          <circle cx="148" cy="255" r="14" fill="#5028d8"></circle>
          <circle cx="61" cy="205" r="14" fill="#7040ff"></circle>
          <circle cx="61" cy="105" r="14" fill="#6030f0"></circle>
        </g>
        <polygon points="126,123 126,187 190,155" fill={`url(#${gradientId})`}></polygon>

      </svg>
      </div>
    </div>
  );
};

export default AnimatedWaitingIcon;

        // <svg
          // version="1.1"
          // id="L7"
          // xmlns="http://www.w3.org/2000/svg"
          // xmlnsXlink="http://www.w3.org/1999/xlink"
          // viewBox="0 0 100 100"
          // width={width}
          // height={height}
        // >
          // <path
            // fill={c1}
            // d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3
            // c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
          // >
            // <animateTransform
              // attributeName="transform"
              // attributeType="XML"
              // type="rotate"
              // dur="2s"
              // from="0 50 50"
              // to="360 50 50"
              // repeatCount="indefinite"
            // />
          // </path>

          // <path
            // fill={c2}
            // d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7
            // c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
          // >
            // <animateTransform
              // attributeName="transform"
              // attributeType="XML"
              // type="rotate"
              // dur="1s"
              // from="0 50 50"
              // to="-360 50 50"
              // repeatCount="indefinite"
            // />
          // </path>

          // <path
            // fill={c3}
            // d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5
            // L82,35.7z"
          // >
            // <animateTransform
              // attributeName="transform"
              // attributeType="XML"
              // type="rotate"
              // dur="2s"
              // from="0 50 50"
              // to="360 50 50"
              // repeatCount="indefinite"
            // />
          // </path>
        // </svg>